"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _css = _interopRequireDefault(require("@styled-system/css"));

var _system = _interopRequireWildcard(require("../../../utils/system"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  /**
   * The content, is recommended use an a icon component
   */
  children: _propTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the components.
   */
  classes: (0, _propTypes.shape)({
    root: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func])
  })
};
var defaultProps = {
  classes: {
    root: null
  }
};
var FormAddonElementLeft = (0, _system["default"])('div')({
  label: 'FormAddonElementLeft'
}, (0, _css["default"])({
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  transform: 'translateY(-50%)',
  color: 'text',
  top: '50%',
  left: 2
}), (0, _system.classesStyles)('root'));
FormAddonElementLeft.displayName = 'FormAddonElementLeft';
FormAddonElementLeft.propTypes = propTypes;
FormAddonElementLeft.defaultProps = defaultProps;
var _default = FormAddonElementLeft;
exports["default"] = _default;

//# sourceMappingURL=FormAddonElementLeft.js.map